import {
  REPORTDETAILSDATA,
  REPORTDETAILSSUMMARY,
  FETCH,
  FETCH2,
  CONTACTDATAFETCH,
  SETSCHEDULEDATA,
  SETDBSCHEDULEDATA,
} from './actionType'
import axios from 'axios'
import tapConfig from './../../tapConfig'

export function reportDetailsData(blossomID, jobID, page, pageSize, response) {
  page = page + 1
  return function (dispatch) {
    tapConfig()
      .then((config) => {
        const apiKey = config.target_outreach_manager.apiKey
        dispatch(contactDataFetching(true))
        axios
          .get(
            config.target_outreach_manager.url +
              'target_emergency_alerts/v1/reports/details?key=' +
              encodeURIComponent(apiKey) +
              '&group_id=' +
              encodeURIComponent(blossomID) +
              '&job_number=' +
              encodeURIComponent(jobID) +
              '&page=' +
              encodeURIComponent(page) +
              '&per_page=' +
              encodeURIComponent(pageSize) +
              '&response=' +
              encodeURIComponent(response),
          )
          .then(function (response) {
            dispatch(reportDetailsDataResponseData(response))
            dispatch(contactDataFetching(false))
          })
          .catch(function () {
            dispatch(contactDataFetching(false))
          })
      })
      .catch((error) => {
        console.error('Error fetching tapConfig:', error)
        dispatch(contactDataFetching(false))
      })
  }
}

export function reportDetailsSummary(jobID, blossomID) {
  return function (dispatch) {
    tapConfig()
      .then((config) => {
        const apiKey = config.target_outreach_manager.apiKey
        dispatch(apiFetching(true))
        axios
          .get(
            config.target_outreach_manager.url +
              'target_emergency_alerts/v1/reports/summaries?key=' +
              encodeURIComponent(apiKey) +
              '&job_number=' +
              encodeURIComponent(jobID) +
              '&group_id=' +
              encodeURIComponent(blossomID),
          )
          .then(function (response) {
            // console.log(response)
            dispatch(reportDetailsSummaryResponseData(response))
            dispatch(apiFetching(false))
          })
          .catch(function () {
            // removed error from function
            // console.log(error)
            dispatch(apiFetching(false))
          })
      })
      .catch((error) => {
        console.error('Error fetching tapConfig:', error)
        dispatch(apiFetching(false))
      })
  }
}

export function changeTheCampaign(action, blossomID, jobID) {
  return function (dispatch) {
    tapConfig()
      .then((config) => {
        const apiKey = config.target_outreach_manager.apiKey
        dispatch(apiFetching2(true))
        axios
          .post(
            config.target_outreach_manager.url +
              'target_emergency_alerts/v1/campaigns/' +
              action +
              '?key=' +
              encodeURIComponent(apiKey),
            {
              group_id: blossomID,
              job_number: Number(jobID),
            },
          )
          .then(function (response) {
            // Added below to  get a pop up window when successful
            if (response.status === 201) {
              if (action === 'stop') {
                window.alert('Campaign Successfully Stopped')
              } else if (action === 'pause') {
                window.alert('Campaign Successfully Paused')
              } else if (action === 'resume') {
                window.alert('Campaign Successfully Resumed')
              }
            } else {
              window.alert(
                'There was an issue with your Campaign status update request!',
              )
            }
            // dispatch(reportDetails(job_number))
            dispatch(apiFetching2(false))
          })
          .catch(function () {
            // removed error from function
            window.alert(
              'There was an issue with your Campaign status update request!',
            )
            dispatch(apiFetching2(false))
          })
      })
      .catch((error) => {
        console.error('Error fetching tapConfig:', error)
        dispatch(apiFetching2(false))
      })
  }
}

export function updateTheCampaignSchedule(blossomID, jobID, schedule) {
  return function (dispatch) {
    return new Promise((resolve, reject) => {
      tapConfig()
        .then((config) => {
          const apiKey = config.target_outreach_manager.apiKey
          dispatch(apiFetching2(true))
          axios
            .post(
              config.target_outreach_manager.url +
                'target_emergency_alerts/v1/campaigns/edit/schedule' +
                '?key=' +
                encodeURIComponent(apiKey),
              {
                group_id: blossomID,
                job_number: Number(jobID),
                schedule: schedule,
              },
            )
            .then(function (response) {
              // Added below to  get a pop up window when successful
              if (response.status === 201) {
                window.alert('Campaign Schedule Successfully Updated ')
                resolve()
              } else {
                window.alert(
                  'There was an issue with your Campaign status update request! Request might have been submitted after campaign has started.',
                )
                reject()
              }
              dispatch(apiFetching2(false))
            })
            .catch(function () {
              // removed error from function
              window.alert(
                'There was an issue with your Campaign status update request!',
              )
              reject()
              dispatch(apiFetching2(false))
            })
        })
        .catch((error) => {
          console.error('Error fetching tapConfig:', error)
          dispatch(apiFetching2(false))
          reject(error)
        })
    })
  }
}

export function download(jobID, group_id) {
  return function (dispatch) {
    tapConfig()
      .then((config) => {
        const apiKey = config.target_outreach_manager.apiKey
        dispatch(apiFetching2(true))
        axios
          .get(
            config.target_outreach_manager.url +
              'target_emergency_alerts/v1/reports/downloads?key=' +
              encodeURIComponent(apiKey) +
              '&job_number=' +
              encodeURIComponent(jobID) +
              '&group_id=' +
              encodeURIComponent(group_id),
          )
          .then(function (response) {
            const url = window.URL.createObjectURL(
              new Blob([response.data], { type: 'text/csv' }),
            )
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'Download.csv')
            document.body.appendChild(link)
            link.click()
          })
          .catch(function () {
            window.alert('There was an issue with your download request!')
            dispatch(apiFetching2(false))
          })
      })
      .catch((error) => {
        console.error('Error fetching tapConfig:', error)
        dispatch(apiFetching2(false))
      })
  }
}

function reportDetailsDataResponseData(response) {
  return {
    type: REPORTDETAILSDATA,
    data: response.data,
  }
}

function reportDetailsSummaryResponseData(response) {
  return {
    type: REPORTDETAILSSUMMARY,
    data: response.data,
  }
}

function apiFetching(status) {
  return {
    type: FETCH,
    fetching: status,
  }
}
function apiFetching2(status) {
  return {
    type: FETCH2,
    fetching: status,
  }
}

function contactDataFetching(status) {
  return {
    type: CONTACTDATAFETCH,
    contactDataFetching: status,
  }
}

export function setScheduleData(data) {
  return {
    type: SETSCHEDULEDATA,
    data: data,
  }
}

export function setDBScheduleData(data) {
  return {
    type: SETDBSCHEDULEDATA,
    data: data,
  }
}
